<div appModal class="profile-video-view" [mainClass]="'lg-modal'" (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">
      <h2 class="mb-3 text-xl">{{ profile.firstName }} {{ profile.lastName }}</h2>
    </div>
    <div class="modal--subtitle">
      <p class="mb-3">{{ profile?.userDetails?.graduationYear }} {{ profile?.userDetails?.positions }}</p>
      <p>{{ profile?.userDetails?.city }}, {{ profile?.userDetails?.state }}</p>
    </div>
  </section>
  <section class="modal-content-container">
    <div class="view">
      <div
        *ngIf="selectedVideo"
        video-player
        [videoId]="selectedVideo.id"
        [video]="selectedVideo"
        [controls]="true"
        [source]="selectedVideo.url"
        [autoplay]="true"
        [dontLoop]="true"
        (onPlay)="onPlay($event)"
        (onPause)="onPause($event)"
        (onSeek)="onSeek($event)"
        (onError)="onError($event)"
        (onPlaybackFinished)="playbackFinished($event)"
        (getReference)="getPlayerRef($event)"
      ></div>
    </div>
    <div class="flex justify-end items-center mt-20" *ngIf="clips.length">
      <span class="font-extrabold">Autoplay {{ autoplay ? 'On' : 'Off' }}</span>
      <app-toggle-switch title="autoplay" [checked]="autoplay" (toggle)="toggleAutoplay()"></app-toggle-switch>
    </div>
    <div class="section--content">
      <div class="section section--videos" [class.show-navigation-buttons]="navigationButtonsVisible">
        <div class="section-previous navigation-button mt-5" [class.hide]="hideLeftArrow" (click)="scrollBack()">
          <svg-icon class="arrow-icon" src="assets/images/svg/rebrand/arrow-left.svg"></svg-icon>
        </div>
        <cdk-virtual-scroll-viewport
          itemSize="50"
          orientation="horizontal"
          class="section section-videos scroll-always"
          (scroll)="onScroll($event)"
          #relatedVideos
        >
          <!-- <div class="section section-videos scroll-always" (scroll)="onScroll($event)" #relatedVideos> -->
          <ng-container *cdkVirtualFor="let customVideo of clips; let i = index">
            <article
              videoCardV2
              [index]="i"
              [thumbnail]="{ source: customVideo?.urlThumb }"
              [playingNowOverlay]="i === currentClipIndex"
              [videoDetails]="[
                { text: customVideo.name },
                { text: customVideo.eventName },
                { text: customVideo.uploadedAt || customVideo.createdAt | date: 'MMMM d, y':'UTC' }
              ]"
              (onSelect)="playVideo(i)"
              class="cursor-pointer"
            ></article>
          </ng-container>
          <!-- </div> -->
        </cdk-virtual-scroll-viewport>
        <div class="section-next navigation-button mt-5" [class.hide]="hideRightArrow" (click)="scrollForward()">
          <svg-icon class="arrow-icon" src="assets/images/svg/rebrand/arrow-right.svg"></svg-icon>
        </div>
      </div>
    </div>
  </section>
</div>
